import TagManager from 'react-gtm-module'
import { GTMTypes, UserTypes } from 'types'
import { STORAGE_KEYS } from 'src/constants'

const Gtm: any = {}

Gtm.pushFlowEvent = (eventName: string, obj: Object) => {
    const ecommerceObj = Object.assign({currencyCode: 'EUR'} , obj)
    TagManager.dataLayer({
        dataLayer: {
            flow: 'New Surplus Order',
            event: eventName,
            ecommerce: ecommerceObj
        }
    })
}

function getUserInfo() {
    const sessionAccount: string = localStorage.getItem(STORAGE_KEYS.ACCOUNT) || ''
    const User = sessionAccount && JSON.parse(sessionAccount)
    return User
}

Gtm.pushPageType = (pageType: GTMTypes.PageTypes) => {
    const User: UserTypes.User = getUserInfo()
    const pageObj: GTMTypes.PageType = {
        visitor: !!User ? (User.role.toLowerCase() === 'customer' ? 'klant' : 'vertegenwoordiger') : '',
        userId: !!User ? User.id : '',
        status: !!User ? 'ingelogd' : 'niet ingelogd',
        pageType: pageType,
        company: !!User ? User.companyId : ''
    }
    TagManager.dataLayer({dataLayer: pageObj })
}

Gtm.init = () => {
    const tagManagerArgs = {
        gtmId: 'GTM-P7B7VL'
    }
    TagManager.initialize(tagManagerArgs)
}

export default Gtm



// WEBPACK FOOTER //
// ./src/helpers/Gtm/index.tsx